import { createSlice } from "@reduxjs/toolkit";

const initialTimelineFilters = {
  selectedTestType: "",
  selectedFilter: "all",
  selectedSubject: "overall",
};

const initialState = {
  timelineView: {
    ...initialTimelineFilters,
  },
};

export const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setTimelineFilters: (state, action) => {
      state.timelineView = {
        ...state.timelineView,
        ...action.payload,
      };
    },
    resetTimelineFilters: (state) => {
      state.timelineView = { ...initialTimelineFilters };
    },
    resetAllFilters: (state) => {
      state.timelineView = { ...initialTimelineFilters };
      // Add other filter resets here as needed
    },
  },
});

export const { setTimelineFilters, resetTimelineFilters, resetAllFilters } = filtersSlice.actions;

export const selectTimelineFilters = (state) => state.filters.timelineView;
export const selectTimelineTestType = (state) => state.filters.timelineView.selectedTestType;
export const selectTimelineCurrentPage = (state) => state.filters.timelineView.currentPage;
export default filtersSlice.reducer;
